(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/click-payload.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/click-payload.js'); "use strict";

const clickedElements = new Set();
const {
  checkIfDataAttributesExists,
  getDataAttributeValue
} = svs.components.adobeTargetPayloadHandler.helpers;
const logger = svs.core.log.getLogger('components:adobe-target-payload-handler');
const CRM_MBOX = 'crmMbox';
const CRM_METRICS_CLICK = 'crmMetricsClick';

const errorHandlerTarget = error => {
  logger.warn("call to target notification for CLICK went wrong ".concat(error.toString()), error);
};

const getValidClickNodes = element => {
  if (Object.prototype.hasOwnProperty.call(element.dataset, CRM_MBOX)) {
    return false;
  }

  const {
    nodeName,
    parentElement
  } = element;

  if (nodeName === 'BUTTON' || nodeName === 'A') {
    return true;
  } else if (parentElement) {
    return getValidClickNodes(parentElement);
  }

  return false;
};

const sendClickPayload = (clickEvent, widgetElement) => {
  const {
    click: targetClick
  } = svs.components.adobeTargetNotification;

  if (!clickedElements.has(widgetElement)) {
    if (getValidClickNodes(clickEvent.target)) {
      clickedElements.add(widgetElement);

      if (checkIfDataAttributesExists(widgetElement, [CRM_MBOX, CRM_METRICS_CLICK])) {
        const mbox = getDataAttributeValue(widgetElement, CRM_MBOX);
        const token = getDataAttributeValue(widgetElement, CRM_METRICS_CLICK);
        targetClick({
          mboxName: mbox,
          tokens: [token],
          errorCallback: errorHandlerTarget
        });
      }
    }
  }
};

const setupClickInMbox = element => {
  element.addEventListener('click', event => {
    sendClickPayload(event, element);
  });
};

svs.components.adobeTargetPayloadHandler.setupClickInMbox = setupClickInMbox;
 })(window);